import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Header } from 'components/HeroSemantic';
import { ThemeButton } from 'components';

export default class StatementRow extends Component {
  static propTypes = {
    year: PropTypes.number,
    month: PropTypes.string.isRequired,
    balance: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  renderPropertyInfo() {
    const { balance } = this.props;
    return (
      <Header as="h2">
        {balance?.property?.strata ?? ''}
        <Header.Subheader>
          {balance?.property?.name ?? ''}
        </Header.Subheader>
      </Header>
    );
  }

  renderViewButton() {
    const { balance, year, month, onClick } = this.props;
    const strata = balance?.property?.strata;
    return (
      <ThemeButton
        fluid
        iconName="eye"
        titleId="general.view"
        disabled={!year || !month || month === 'All'}
        onClick={() => onClick(strata, false)}
      />
    );
  }

  renderDownloadButton() {
    const { balance, year, month, onClick } = this.props;
    const strata = balance?.property?.strata;
    return (
      <ThemeButton
        fluid
        iconName="download"
        titleId="general.download"
        disabled={!year || !month}
        onClick={() => onClick(strata, true)}
      />
    );
  }

  render() {
    return (
      <div className="flex flex-col gap-4 border-b border-[var(--owner-border)] py-4 last:border-b-0 sm:flex-row sm:items-center sm:gap-6">
        <div className="min-w-0 flex-1">{this.renderPropertyInfo()}</div>
        <div className="flex w-full flex-col gap-2 sm:w-auto sm:flex-row sm:gap-3">
          <div className="w-full sm:w-[140px]">{this.renderViewButton()}</div>
          <div className="w-full sm:w-[160px]">{this.renderDownloadButton()}</div>
        </div>
      </div>
    );
  }
}
